var mod = function (n, m) {
  return (n % m + m) % m;
};
export default mod;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/mod.js
// module id = 73
// module chunks = 0